/**
 * PHARMAKON - useToast Hook
 * Toast notification system with context
 */

import { useContext } from "react";
import { ToastContext } from "../context/toastContext.js";

export const useToast = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error("useToast must be used within ToastProvider");
  }

  return context;
};

export default useToast;
